import { Globe } from "@/components/icons"

type WebSourceIconProps = {
  hostname: string
  className?: string
  fallbackClassName?: string
  iconClassName?: string
}

export function WebSourceIcon({
  hostname,
  className = "bg-muted flex size-5 shrink-0 items-center justify-center rounded-full",
  fallbackClassName = "text-muted-foreground hidden size-3",
  iconClassName = "size-3",
}: WebSourceIconProps) {
  if (!hostname) {
    const visibleFallbackClassName = fallbackClassName.replace(/\bhidden\b\s*/, "")
    return <Globe aria-hidden className={visibleFallbackClassName} />
  }

  return (
    <span className={className}>
      <img
        aria-hidden
        alt=""
        className={iconClassName}
        src={`https://icons.duckduckgo.com/ip3/${hostname}.ico`}
        onError={(event) => {
          event.currentTarget.style.display = "none"
          const sibling = event.currentTarget.nextElementSibling as HTMLElement | null
          sibling?.classList.remove("hidden")
        }}
      />
      <Globe aria-hidden className={fallbackClassName} />
    </span>
  )
}
